<template>
    <div >
        <button :class="{classes}" :type="inputype" >{{ buttontext }} </button>
    </div>
</template>

<script>
export default {
    data() {
        return{
            
        }
    },
    props : {
        inputype : String,
        Placeholder : String,
        buttontext: String,
        classes : String
    }
}
</script>